import { render, staticRenderFns } from "./CajaResumenToolbar.vue?vue&type=template&id=bb3c3bbc&scoped=true&lang=pug"
import script from "./CajaResumenToolbar.vue?vue&type=script&lang=js"
export * from "./CajaResumenToolbar.vue?vue&type=script&lang=js"
import style0 from "./CajaResumenToolbar.vue?vue&type=style&index=0&id=bb3c3bbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3c3bbc",
  null
  
)

export default component.exports